import { useQuery } from '@apollo/react-hooks';
import { QueryLanguages_getLanguages_languages } from '~graphql/__generated__/QueryLanguages';
import { GET_LANGUAGES } from '~graphql/booking';

function useLanguages() {
  const { data } = useQuery(GET_LANGUAGES);
  const languages: (QueryLanguages_getLanguages_languages | null)[] = data?.getLanguages?.languages?.filter(
    (language: QueryLanguages_getLanguages_languages) => language?.abbreviation !== 'FR'
  );

  return languages?.map(language => {
    return {
      value: language?.abbreviation,
      label: language?.language,
    };
  });
}

export { useLanguages };
